import React, { useEffect, useState } from "react"
import { Modal } from "react-bootstrap";
import { BigPictureDashBoardPieChartLegend, Common, KSResultsCommonOptions, KSResultsScienceOptions, previousYearOutcome, previousYearOutcomeSubjects, SessionStorageKeys } from "../../../helper";
import * as commonApi from "../../../api/commonApi";

import "../../../assets/stlyes/SchoolAdminTableStyle.scss";
import "./CompleteBaseLineDataTable.scss"
import { LoadingSpinner } from "../../Shared";
import { isEmptyObject, SessionStorage } from "../../../util";

import AcademicFilterIcon from "../../../assets/images/AcademicFilterIcon.svg"

const CompleteTeachersData = ({ setAllPupil, setFullScreen, setPupilAcademicDetails }) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState( false );
  const [pupilDetails, setPupilDetails] = useState();
  const [headerOption, setHeaderOption] = useState("");
  const [mathsSelected, setMathsSelected] = useState("");
  const [readingSelected, setReadingSelected] = useState("");
  const [writingSelected, setWritingSelected] = useState("");
  const [scienceSelected, setScienceSelected] = useState("");
  const [mathsSelectedOutcome, setMathsSelectedOutcome] = useState("");
  const [readingSelectedOutcome, setReadingSelectedOutcome] = useState("");
  const [writingSelectedOutcome, setWritingSelectedOutcome] = useState("");
  const [scienceSelectedOutcome, setScienceSelectedOutcome] = useState("");

  const getAllPupil = async () => {
    setIsLoading(true);
    setOpen(true);
    const storedPupilAcademicDetails = JSON.parse(SessionStorage.getItem(SessionStorageKeys.SavePupilAcademicDetails));

    let allPupils = !isEmptyObject(storedPupilAcademicDetails) ? storedPupilAcademicDetails : await commonApi.getAllAssignedStudents();
    setPupilDetails(storedPupilAcademicDetails ? allPupils :allPupils?.Items);
    setIsLoading(false);
  }

  const handleCancel = () => {
    setOpen(false)
    setAllPupil(false);
  }

  const handleSave = () =>{
    setOpen(false)
    const pupilResponse = commonApi.pupilBulkUpdate(pupilDetails)
    console.log({pupilResponse})
    setAllPupil(false);
  }

  useEffect(() => {
    getAllPupil();
  }, [])
  useEffect(() => {
    setPupilAcademicDetails(pupilDetails);
  }, [pupilDetails])

  const handleHeaderOptionChange = (event) => {
    const { value } = event.target;
    setHeaderOption(value === "yes");
    setPupilDetails((prevState) =>
      prevState.map((pupil) => ({ ...pupil, eyfs: value === "yes" }))
    );
  };

  const handlePupilOptionChange = (event, index) => {
    const { value } = event.target;
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) => (i === index ? { ...pupil, eyfs: value === "yes" } : pupil))
    );
  };

  const handleMathsHeaderChange = (event) => {
    const { value } = event.target;
    const updatedMaths = value === "Absent/ Dissaplied/ Unknown" ? "" : value === "Below/ Pre key Stage Foundations/ Engagement Model" ? "BLW" : value === "Greater Depth" ? "GDS" : value === "Working Towards" ? "WTS" : value === "Expected Standard" ? "EXS" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 2) {
          const updatedKs1Results = {
            ...pupil.ksResults.ks1Results,
            Maths: updatedMaths
          };

          return {
            ...pupil,
            ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results }
          };
        }

        return pupil
      })
    );
    setMathsSelected(value);
  };

  const handleMathsOptionChange = (event, index) => {
    const { value } = event.target;
    const updatedKs1Results = {
      ...pupilDetails[index].ksResults.ks1Results,
      Maths: value === "Absent/ Dissaplied/ Unknown" ? "" : value === "Below/ Pre key Stage Foundations/ Engagement Model" ? "BLW" : value === "Greater Depth" ? "GDS" : value === "Working Towards" ? "WTS" : value === "Expected Standard" ? "EXS" : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results } } : pupil
      )
    );
  };

  const handleReadingHeaderChange = (event) => {
    const { value } = event.target;
    const updatedReading = value === "Absent/ Dissaplied/ Unknown" ? "" : value === "Below/ Pre key Stage Foundations/ Engagement Model" ? "BLW" : value === "Greater Depth" ? "GDS" : value === "Working Towards" ? "WTS" : value === "Expected Standard" ? "EXS" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 2) {
          const updatedKs1Results = {
            ...pupil.ksResults.ks1Results,
            Reading: updatedReading
          };

          return {
            ...pupil,
            ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results }
          };
        }
        return pupil
      })
    );
    setReadingSelected(value);
  };

  const handleReadingOptionChange = (event, index) => {
    const { value } = event.target;
    const updatedKs1Results = {
      ...pupilDetails[index].ksResults.ks1Results,
      Reading: value === "Absent/ Dissaplied/ Unknown" ? "" : value === "Below/ Pre key Stage Foundations/ Engagement Model" ? "BLW" : value === "Greater Depth" ? "GDS" : value === "Working Towards" ? "WTS" : value === "Expected Standard" ? "EXS" : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results } } : pupil
      )
    );
  };

  const handleScienceHeaderChange = (event) => {
    const { value } = event.target;
    const updatedScience = value === "Absent/ Dissaplied/ Unknown" ? "D" : value === "Has Not Met" ? "HNM" : value === "Expected Standard" ? "EXS" : ""
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 2) {
          const updatedKs1Results = {
            ...pupil.ksResults.ks1Results,
            Science: updatedScience
          };
          return {
            ...pupil,
            ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results }
          };
        }

        return pupil
      })
    );
    setScienceSelected(value);
  };

  const handleScienceOptionChange = (event, index) => {
    const { value } = event.target;
    const updatedKs1Results = {
      ...pupilDetails[index].ksResults.ks1Results,
      Science: value === "Absent/ Dissaplied/ Unknown" ? "D" : value === "Has Not Met" ? "HNM" : value === "Expected Standard" ? "EXS" : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results } } : pupil
      )
    );
  };

  const handleWritingHeaderChange = (event) => {
    const { value } = event.target;
    const updatedWriting = value === "Absent/ Dissaplied/ Unknown" ? "" : value === "Below/ Pre key Stage Foundations/ Engagement Model" ? "BLW" : value === "Greater Depth" ? "GDS" : value === "Working Towards" ? "WTS" : value === "Expected Standard" ? "EXS" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 2) {
          const updatedKs1Results = {
            ...pupil.ksResults.ks1Results,
            Writing: updatedWriting
          };
          return {
            ...pupil,
            ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results }
          };
        }
        return pupil
      })
    );
    setWritingSelected(value);
  };

  const handleWritingOptionChange = (event, index) => {
    const { value } = event.target;
    const updatedKs1Results = {
      ...pupilDetails[index].ksResults.ks1Results,
      Writing: value === "Absent/ Dissaplied/ Unknown" ? "" : value === "Below/ Pre key Stage Foundations/ Engagement Model" ? "BLW" : value === "Greater Depth" ? "GDS" : value === "Working Towards" ? "WTS" : value === "Expected Standard" ? "EXS" : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, ksResults: { ...pupil.ksResults, ks1Results: updatedKs1Results } } : pupil
      )
    );
  };

  const handleMathsHeaderOutcome = (event) => {
    const { value } = event.target;
    const updatedMaths = value === "BLW" ? "B" : value === "GDS" ? "G" : value === "WTS" ? "W" : value === "EXS" ? "E" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 1) {
          pupil.previousYearOutcome = {
            ...pupil.previousYearOutcome,
            Maths: `${pupil.year - 1}${updatedMaths}`
          };
          return pupil
        }

        return pupil
      })
    );
    setMathsSelectedOutcome(value);
  };

  const handleMathsOptionOutcome = (event, index) => {
    const { value } = event.target;
    const year = value.slice(0, 1);
    const mark = value.slice(2);
    const updatedpreviousYearOutcome = {
      ...pupilDetails[index].previousYearOutcome,
      Maths: mark === "BLW" ? `${year}B` : mark === "GDS" ? `${year}G` : mark === "WTS" ? `${year}W` : mark === "EXS" ? `${year}E` : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, previousYearOutcome: updatedpreviousYearOutcome } : pupil
      )
    );
  };

  const handleReadingHeaderOutcome = (event) => {
    const { value } = event.target;
    const updatedReading = value === "BLW" ? "B" : value === "GDS" ? "G" : value === "WTS" ? "W" : value === "EXS" ? "E" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 1) {
          pupil.previousYearOutcome = {
            ...pupil.previousYearOutcome,
            Reading: `${pupil.year - 1}${updatedReading}`
          };
          return pupil
        }

        return pupil
      })
    );
    setReadingSelectedOutcome(value);
  };

  const handleReadingOptionOutcome = (event, index) => {
    const { value } = event.target;
    const year = value.slice(0, 1);
    const mark = value.slice(2);
    const updatedpreviousYearOutcome = {
      ...pupilDetails[index].previousYearOutcome,
      Reading: mark === "BLW" ? `${year}B` : mark === "GDS" ? `${year}G` : mark === "WTS" ? `${year}W` : mark === "EXS" ? `${year}E` : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, previousYearOutcome: updatedpreviousYearOutcome } : pupil
      )
    );
  };

  const handleWritingHeaderOutcome = (event) => {
    const { value } = event.target;
    const updatedWriting = value === "BLW" ? "B" : value === "GDS" ? "G" : value === "WTS" ? "W" : value === "EXS" ? "E" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 1) {
          pupil.previousYearOutcome = {
            ...pupil.previousYearOutcome,
            Writing: `${pupil.year - 1}${updatedWriting}`
          };
          return pupil
        }

        return pupil
      })
    );
    setWritingSelectedOutcome(value);
  };

  const handleWritingOptionOutcome = (event, index) => {
    const { value } = event.target;
    const year = value.slice(0, 1);
    const mark = value.slice(2);
    const updatedpreviousYearOutcome = {
      ...pupilDetails[index].previousYearOutcome,
      Writing: mark === "BLW" ? `${year}B` : mark === "GDS" ? `${year}G` : mark === "WTS" ? `${year}W` : mark === "EXS" ? `${year}E` : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, previousYearOutcome: updatedpreviousYearOutcome } : pupil
      )
    );
  };

  const handleScienceHeaderOutcome = (event) => {
    const { value } = event.target;
    console.log({Bharath:value});
    //  mark === "BLW" ? `${year}B` : mark === "GDS" ? `${year}G` : mark === "WTS" ? `${year}W` : mark === "EXS" ? `${year}E` : ""
    const updatedScience = value === "BLW" ? "B" : value === "WTS" ? "W" : value === "EXS" ? "E" : value === "GDS" ? "G" : "";
    // const updatedScience = value === "D" ? "B" : value === "HNM" ? "W" : value === "EXS" ? "E" : "";
    setPupilDetails((prevState) =>
      prevState.map((pupil) => {
        if (pupil.year > 1) {
          pupil.previousYearOutcome = {
            ...pupil.previousYearOutcome,
            Science: `${pupil.year - 1}${updatedScience}`
          };
          return pupil
        }

        return pupil
      })
    );
    setScienceSelectedOutcome(value);
  };

  const handleScienceOptionOutcome = (event, index) => {
    const { value } = event.target;
    const year = value.slice(0, 1);
    const mark = value.slice(2);
    const updatedpreviousYearOutcome = {
      ...pupilDetails[index].previousYearOutcome,
      Science: mark === "BLW" ? `${year}B` : mark === "GDS" ? `${year}G` : mark === "WTS" ? `${year}W` : mark === "EXS" ? `${year}E` : ""
    };
    setPupilDetails((prevState) =>
      prevState.map((pupil, i) =>
        i === index ? { ...pupil, previousYearOutcome: updatedpreviousYearOutcome } : pupil
      )
    );
  };

  const getDisplayValue = (apiValue) => {
    switch (apiValue) {
    case "EXS":
      return "Expected Standard";
    case "WTS":
      return "Working Towards";
    case "GDS":
      return "Greater Depth";
    case "BLW":
      return "Below/ Pre key Stage Foundations/ Engagement Model";
    case "HNM":
      return "Has Not Met";
    default:
      return "Absent/ Dissaplied/ Unknown";
    }
  };

  const getDisplayOutcome = (apiValue) => {
    const year = apiValue ? apiValue.slice(0, 1) : "";
    const outcome = apiValue ? apiValue.slice(1) : "";
    switch (outcome) {
    case "E":
      return `${year} EXS`;
    case "W":
      return `${year} WTS`;
    case "G":
      return `${year} GDS`;
    case "B":
      return `${year} BLW`;
    case "A":
      return "Absent/ Dissaplied/ Unknown";
    default:
      return "";
    }
  };

  const generateSelectHeader = (label, onChangeHandler, value, options) => {
    return (
      <div>
        <select onChange={onChangeHandler} value={value} className="academic-details-ks-select-dropdown">
          {options.map((option, index) => (
            <option key={index}>{option}</option>
          ))}
        </select>
      </div>
    );
  };

  const generateSelectBody = (disabled, value, onChangeHandler, options, displayOutcome, pupil) => {
    return (
      <select disabled={disabled} value={value} onChange={onChangeHandler} className={`academic-details-ks-select-dropdown ${disabled ? "academic-details-ks-select-dropdown-disabled" : ""}`}>
        {!displayOutcome ? pupil.year>2 && options.map((option, index) => (
          <option key={index}>{option}</option>
        )) :
          [...Array(pupil.year - 1).keys()].map((year) => (
            <React.Fragment key={year}>
              <option>{`${year + 1} WTS`}</option>
              <option>{`${year + 1} EXS`}</option>
              <option>{`${year + 1} GDS`}</option>
            </React.Fragment>
          ))}
      </select>
    );
  };

  return (
    <div>
      {isLoading? <LoadingSpinner/> : (false && <Modal show={open} fullscreen={open} className="gld-modal">
        <Modal.Header className="gldKsHeader">
          <div className="gldfullName">{"Full Name"}</div>
          <div className="gldUPN">{"UPN"}</div>
          <div className="gldYear">{"Year"}</div>
          <div className="gldHeaderMain">
            <div className="gldText">{Common.GLDStatus}</div>
            <div className="gldYesOrNo ">
              <label><input type="radio" value="yes" checked={headerOption} onChange={handleHeaderOptionChange} />{Common.Yes_}</label>
              <label className="gldHeaderNo"><input type="radio" value="no" checked={!headerOption} onChange={handleHeaderOptionChange} />{Common.No}</label>
            </div>
          </div>
          {generateSelectHeader(BigPictureDashBoardPieChartLegend.Ks1Maths, handleMathsHeaderChange, mathsSelected, KSResultsCommonOptions)}
          {generateSelectHeader(BigPictureDashBoardPieChartLegend.Ks1Reading, handleReadingHeaderChange, readingSelected, KSResultsCommonOptions)}
          {generateSelectHeader(BigPictureDashBoardPieChartLegend.Ks1Writing, handleWritingHeaderChange, writingSelected, KSResultsCommonOptions)}
          {generateSelectHeader(BigPictureDashBoardPieChartLegend.Ks1Science, handleScienceHeaderChange, scienceSelected, KSResultsScienceOptions)}
          {generateSelectHeader(previousYearOutcomeSubjects.PYOMaths, handleMathsHeaderOutcome, mathsSelectedOutcome, previousYearOutcome)}
          {generateSelectHeader(previousYearOutcomeSubjects.PYOReading, handleReadingHeaderOutcome, readingSelectedOutcome, previousYearOutcome)}
          {generateSelectHeader(previousYearOutcomeSubjects.PYOWriting, handleWritingHeaderOutcome, writingSelectedOutcome, previousYearOutcome)}
          {generateSelectHeader(previousYearOutcomeSubjects.PYOScience, handleScienceHeaderOutcome, scienceSelectedOutcome, previousYearOutcome)}
        </Modal.Header>
        <Modal.Body className="comment-modal-body gldKsBody">
          {pupilDetails?.map((pupil, ind) => {
            return <div key={ind} className="pupil-flex justify-content-between">
              <div className="gldfullName">{`${pupil.lastName} ${pupil.firstName}`}</div>
              <div className="gldUPN">{pupil.upn}</div>
              <div className="gldYear">{pupil.year}</div>
              <div className="gldYesOrNo">
                <label><input type="radio" value="yes" checked={pupil.eyfs} onChange={(e) => handlePupilOptionChange(e, ind)} />{Common.Yes_}</label>
                <label><input type="radio" value="no" checked={!pupil.eyfs} onChange={(e) => handlePupilOptionChange(e, ind)} />{Common.No}</label>
              </div>
              {generateSelectBody(pupil.year < 3, getDisplayValue(pupil.ksResults.ks1Results.Maths), (e) => handleMathsOptionChange(e, ind), KSResultsCommonOptions, false, pupil)}
              {generateSelectBody(pupil.year < 3, getDisplayValue(pupil.ksResults.ks1Results.Reading), (e) => handleReadingOptionChange(e, ind), KSResultsCommonOptions, false, pupil)}
              {generateSelectBody(pupil.year < 3, getDisplayValue(pupil.ksResults.ks1Results.Writing), (e) => handleWritingOptionChange(e, ind), KSResultsCommonOptions, false, pupil)}
              {generateSelectBody(pupil.year < 3, getDisplayValue(pupil.ksResults.ks1Results.Science), (e) => handleScienceOptionChange(e, ind), KSResultsScienceOptions, false, pupil)}
              {generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Maths), (e) => handleMathsOptionOutcome(e, ind), previousYearOutcome, true, pupil)}
              {generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Reading), (e) => handleReadingOptionOutcome(e, ind), previousYearOutcome, true, pupil)}
              {generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Writing), (e) => handleWritingOptionOutcome(e, ind), previousYearOutcome, true, pupil)}
              {generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Science), (e) => handleScienceOptionOutcome(e, ind), previousYearOutcome, true, pupil)}
            </div>
          })}
        </Modal.Body>
        <Modal.Footer className="comment-modal-footer">
          <button className="comment-modal-cancelbtn cancelButton" type="button" onClick={handleCancel}>{Common.Cancel}</button>
          <button name="addComment" className="comment-modal-savebtn saveButton" onClick={handleSave}> {Common.Save}</button>
        </Modal.Footer>
      </Modal>)}

      {isLoading? <LoadingSpinner/> : <div className="table-container" style={{ paddingRight: setFullScreen() }}>
        <table>
          <thead className="first-header">
            <tr>
              <th style={{backgroundColor:"#F34970",textAlign:"end"}}><img src={AcademicFilterIcon} alt="AcademicFilterIcon" /></th>
              <th></th>
              <th></th>
              <th>{generateSelectHeader(previousYearOutcomeSubjects.PYOMaths, handleMathsHeaderOutcome, mathsSelectedOutcome, previousYearOutcome)}</th>
              <th>{generateSelectHeader(previousYearOutcomeSubjects.PYOReading, handleReadingHeaderOutcome, readingSelectedOutcome, previousYearOutcome)}</th>
              <th>{generateSelectHeader(previousYearOutcomeSubjects.PYOWriting, handleWritingHeaderOutcome, writingSelectedOutcome, previousYearOutcome)}</th>
              <th style={{borderRadius:"0px 20px 0px 0px"}}>{generateSelectHeader(previousYearOutcomeSubjects.PYOScience, handleScienceHeaderOutcome, scienceSelectedOutcome, previousYearOutcome)}</th>
            </tr>
            <tr className="second-header">
              <th style={{textAlign:"start"}}>Full Name</th>
              <th>UPN</th>
              <th>Year</th>
              <th>{BigPictureDashBoardPieChartLegend.PreviousYearMaths}</th>
              <th>{BigPictureDashBoardPieChartLegend.PreviousYearReading}</th>
              <th>{BigPictureDashBoardPieChartLegend.PreviousYearWriting}</th>
              <th>{BigPictureDashBoardPieChartLegend.PreviousYearScience}</th>
            </tr>
          </thead>
          <tbody className="academic-details-tbody">
            {pupilDetails?.map((pupil, ind) => (
              <tr key={ind}>
                <td>{`${pupil.lastName} ${pupil.firstName}`}</td>
                <td>{pupil.upn}</td>
                <td>{pupil.year}</td>
                <td>{generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Maths), (e) => handleMathsOptionOutcome(e, ind), previousYearOutcome, true, pupil)}</td>
                <td>{generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Reading), (e) => handleReadingOptionOutcome(e, ind), previousYearOutcome, true, pupil)}</td>
                <td>{generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Writing), (e) => handleWritingOptionOutcome(e, ind), previousYearOutcome, true, pupil)}</td>
                <td>{generateSelectBody(pupil.year < 2, getDisplayOutcome(pupil.previousYearOutcome.Science), (e) => handleScienceOptionOutcome(e, ind), previousYearOutcome, true, pupil)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      }
    </div>
  )
}

export { CompleteTeachersData }
